import axios from 'axios';

// По умолчанию — тот же origin, откуда отдан фронтенд: сборка не привязана к домену.
// Для локальной разработки задайте REACT_APP_API_URL в frontend/.env.local
const API_URL = process.env.REACT_APP_API_URL || '/api';
const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const api = {
    getClients: () => axiosInstance.get(`${API_URL}/clients`),
    getClient: (id: number) => axiosInstance.get(`${API_URL}/clients/${id}`),
    createClient: (data: any) => axiosInstance.post(`${API_URL}/clients`, data),
    updateClient: (id: number, data: any) => axiosInstance.put(`${API_URL}/clients/${id}`, data),
    deleteClient: (id: number) => axiosInstance.delete(`${API_URL}/clients/${id}`),

    getKits: () => axiosInstance.get(`${API_URL}/kits`),
    getKit: (id: number) => axiosInstance.get(`${API_URL}/kits/${id}`),
    createKit: (data: any) => axiosInstance.post(`${API_URL}/kits`, data),
    updateKit: (id: number, data: any) => axiosInstance.put(`${API_URL}/kits/${id}`, data),
    deleteKit: (id: number, reason?: string, permanent?: boolean) =>
        axiosInstance.delete(`${API_URL}/kits/${id}`, { data: { reason, permanent } }),
    giveKit: (id: number) => axiosInstance.post(`${API_URL}/kits/${id}/give`),
    getKitsArchive: () => axiosInstance.get(`${API_URL}/kits/archive/all`),
    restoreKit: (id: number) => axiosInstance.post(`${API_URL}/kits/archive/${id}/restore`),
    deleteKitFromArchive: (id: number) => axiosInstance.delete(`${API_URL}/kits/archive/${id}`),
    
    getChips: () => axiosInstance.get(`${API_URL}/chips`),
    getLowStockChips: () => axiosInstance.get(`${API_URL}/chips/low-stock`),
    getShadowChips: () => axiosInstance.get(`${API_URL}/chips/shadow`),
    getChip: (id: number) => axiosInstance.get(`${API_URL}/chips/${id}`),
    searchChips: (query: string) => axiosInstance.get(`${API_URL}/chips/search/${query}`),
    enrichChip: (query: string, pkg?: string) => axiosInstance.get(`${API_URL}/chips/enrich/search/${encodeURIComponent(query)}`, {
        params: pkg ? { package: pkg } : undefined
    }),
    getNextPosition: () => axiosInstance.get(`${API_URL}/chips/next-position`),
    createChip: (data: any) => axiosInstance.post(`${API_URL}/chips`, data),
    getChipDescriptions: () => axiosInstance.get(`${API_URL}/chip-descriptions`),
    createChipDescription: (data: any) => axiosInstance.post(`${API_URL}/chip-descriptions`, data),
    deleteChipDescription: (id: number) => axiosInstance.delete(`${API_URL}/chip-descriptions/${id}`),
    getChipPackages: () => axiosInstance.get(`${API_URL}/chip-packages`),
    createChipPackage: (data: any) => axiosInstance.post(`${API_URL}/chip-packages`, data),
    deleteChipPackage: (id: number) => axiosInstance.delete(`${API_URL}/chip-packages/${id}`),
    updateChip: (id: number, data: any) => axiosInstance.put(`${API_URL}/chips/${id}`, data),
    updateChipQuantity: (id: number, change: number) => axiosInstance.patch(`${API_URL}/chips/${id}/quantity`, { change }),
    shadowChip: (id: number) => axiosInstance.post(`${API_URL}/chips/${id}/shadow`),
    restoreChip: (id: number, data: { section: string; cell: string }) => axiosInstance.post(`${API_URL}/chips/${id}/restore`, data),
    deleteChip: (id: number) => axiosInstance.delete(`${API_URL}/chips/${id}`),
    
    getRepairs: () => axiosInstance.get(`${API_URL}/repairs`),
    getRepair: (id: number) => axiosInstance.get(`${API_URL}/repairs/${id}`),
    getClientRepairs: (clientId: number) => axiosInstance.get(`${API_URL}/repairs/client/${clientId}`),
    getTotalDebt: () => axiosInstance.get(`${API_URL}/repairs/debt/total`),
    createRepair: (data: FormData) => axiosInstance.post(`${API_URL}/repairs`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    updateRepair: (id: number, data: any) => axiosInstance.put(`${API_URL}/repairs/${id}`, data),
    deleteRepair: (id: number, reason?: string, permanent?: boolean) => axiosInstance.delete(`${API_URL}/repairs/${id}`, { data: { reason, permanent } }),
    getRepairsByClient: (clientId: number) => axiosInstance.get(`${API_URL}/repairs/client/${clientId}`),
    cleanupImages: () => axiosInstance.post(`${API_URL}/cleanup-images`),

    // Новые методы для работы с фото ремонтов
    uploadRepairImages: (repairId: number, formData: FormData) => 
        axiosInstance.post(`${API_URL}/repairs/${repairId}/upload-images`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }),
    deleteRepairImage: (repairId: number, imagePath: string) => 
        axiosInstance.delete(`${API_URL}/repairs/${repairId}/delete-image`, { data: { imagePath } }),
    
    getShoppingItems: () => axiosInstance.get(`${API_URL}/shopping`),
    createShoppingItem: (data: { title: string; note?: string }) => axiosInstance.post(`${API_URL}/shopping`, data),
    updateShoppingItem: (id: number, data: { title: string; note?: string }) => axiosInstance.put(`${API_URL}/shopping/${id}`, data),
    toggleShoppingItem: (id: number) => axiosInstance.patch(`${API_URL}/shopping/${id}/toggle`),
    deleteShoppingItem: (id: number) => axiosInstance.delete(`${API_URL}/shopping/${id}`),
    clearBoughtShoppingItems: () => axiosInstance.delete(`${API_URL}/shopping/bought/all`),

    getArchive: () => axiosInstance.get(`${API_URL}/repairs/archive/all`),
    restoreRepair: (id: number) => axiosInstance.post(`${API_URL}/repairs/archive/${id}/restore`),
    deleteFromArchive: (id: number) => axiosInstance.delete(`${API_URL}/repairs/archive/${id}`),
};
